var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cn_title"},[_c('Button',{staticClass:"mR15",attrs:{"type":"info"}},[_vm._v("添加")]),_c('Button',{attrs:{"type":"warning"}},[_vm._v("批量操作")]),_c('ul',[_c('li',[_vm._v(" "+_vm._s(_vm.search)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }